class ProductBar extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event('change', { bubbles: true });
  }

  connectedCallback() {
    this.submitButton = this.querySelector('[name="add"]');
    this.productSelectors = Array.from(
      document
        .querySelector('product-selector')
        ?.querySelectorAll('input[type="radio"], select')
    );
    this.mainAddButton = this.closest('.product')?.querySelector(
      'product-form [name="add"]'
    );
    this.debouncedReflow = debounce(
      () => this.applyStickyBarVisibility(),
      150
    );
    this.scrollToFormButton = this.querySelector(
      '[data-purchase-options-button]'
    );
    this._mainAtcIntersecting = true;
    this.setupMainAtcObserver();
    this.setHandlers();
  }

  disconnectedCallback() {
    this._io?.disconnect();
    this._io = null;
  }

  setupMainAtcObserver() {
    if (!this.mainAddButton) {
      this.applyStickyBarVisibility();
      return;
    }

    this._io = new IntersectionObserver(
      entries => {
        const entry = entries[0];
        if (!entry) return;
        this._mainAtcIntersecting = entry.isIntersecting;
        this.applyStickyBarVisibility();
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0px'
      }
    );
    this._io.observe(this.mainAddButton);
  }

  setHandlers() {
    this.addEventListener('change', event => {
      this.onChange({
        name: event.target.dataset.name || event.target.name,
        value: event.target.value
      });
    });

    window.addEventListener('scroll', this.debouncedReflow.bind(this), {
      passive: true
    });
    window.addEventListener('resize', this.debouncedReflow.bind(this));
    window.addEventListener('load', () => this.applyStickyBarVisibility());
    this.scrollToFormButton?.addEventListener(
      'click',
      this.scrollToForm.bind(this)
    );
  }

  applyStickyBarVisibility() {
    const formActions = document.querySelector('product-form');
    if (!formActions) return;

    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (!isMobile) {
      this.classList.toggle(
        'is-hidden',
        window.scrollY < getOffsetTop(formActions) ||
          window.scrollY + window.innerHeight >= document.body.offsetHeight
      );
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const nearPageBottom =
      window.scrollY + window.innerHeight >= scrollHeight - 80;

    const showBar =
      !this._mainAtcIntersecting && !nearPageBottom;

    this.classList.toggle('is-hidden', !showBar);
  }

  scrollToForm() {
    const target = document.querySelector('product-form');
    const offset =
      document.querySelector('header')?.clientHeight || 0;
    const scrollPosition = target.offsetTop - offset;

    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    });
  }

  onChange({ name, value }) {
    const matchedSelector = this.productSelectors
      .filter(
        selector =>
          selector.dataset.name === name || selector.name === name
      )
      .find(selector => {
        if (selector.type === 'select-one') return selector;
        return selector.value === value;
      });
    if (!matchedSelector)
      throw new Error(`Selector not found with name ${name}`);

    if (matchedSelector.type === 'radio') {
      matchedSelector.click();
      return;
    }

    matchedSelector.value = value;
    Array.from(matchedSelector.options).map(option =>
      option.toggleAttribute('selected', option.value === value)
    );
    matchedSelector.dispatchEvent(this.changeEvent);
  }
}

customElements.define('product-bar', ProductBar);
